'use strict';
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  
  var _SettingOutlined = _interopRequireDefault(require('./lib/icons/SettingOutlined'));
  
  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
  
  var _default = _SettingOutlined;
  exports.default = _default;
  module.exports = _default;